import getPlantDetail from '@apis/plants/getPlantDetail'
import dayjs from 'dayjs'

import checkPlantStatus from './checkPlantStatus'
import getAddress from './getAddress'
import getEnergyBalanceDay from './getEnergyBalanceDay'
import getEnergyBalanceTotal from './getEnergyBalanceTotal'
import getPvPower from './getPvPower'
import getSystemInfo from './getSystemInfo'
import getWeather from './getWeather'

export default async function getDashboard(plant_id) {
  const dateToday = dayjs()

  const addressPromise = getAddress(plant_id)
  const pvPowerPromise = getPvPower(plant_id)
  const temperaturePromise = getWeather(plant_id)
  const energyBalanceTotalPromise = getEnergyBalanceTotal(plant_id)
  const systemInfoPromise = getSystemInfo(plant_id)
  const plantDetailPromise = getPlantDetail(plant_id)
  const energyBalanceDayPromise = getEnergyBalanceDay(plant_id, dateToday)

  const [
    addressResult,
    pvPowerResult,
    temperatureResult,
    energyBalanceTotalResult,
    systemInfoResult,
    plantDetailResult,
    energyBalanceDayResult,
  ] = await Promise.all([
    addressPromise,
    pvPowerPromise,
    temperaturePromise,
    energyBalanceTotalPromise,
    systemInfoPromise,
    plantDetailPromise,
    energyBalanceDayPromise,
  ])

  const plantData = plantDetailResult.data.list[0]

  if (!plantData || plantData.is_active === false){
    return null
  }

  await checkPlantStatus(plant_id)

  const temperature = temperatureResult
  const address = addressResult && {
    city: `${addressResult.address.city} ${addressResult.address.zipCode}`,
    timezone: addressResult.timezone,
  }
  const pvGenerationDay = energyBalanceDayResult && energyBalanceDayResult.total?.pvGeneration
  const graph = energyBalanceDayResult && energyBalanceDayResult.set

  const pvGenerationTotal = energyBalanceTotalResult && energyBalanceTotalResult.data.result.total.pvGeneration

  const systemInfo = systemInfoResult && {
    peakPower: (systemInfoResult.peakPower / 1000).toFixed(1),
    startUpUtc: dayjs(systemInfoResult.startUpUtc).format('DD MMM YYYY'),
    dcPowerInputMax: (systemInfoResult.dcPowerInputMax / 1000).toFixed(1),
  }

  const peakPower = systemInfo && systemInfo.peakPower
  const pvPower = pvPowerResult && pvPowerResult.set[0]?.pvGeneration

  const co2 = plantData && plantData.co2
  const currency = plantData && plantData.currency
  const logo = plantData && plantData.image_base64

  return {
    address,
    dateToday,
    temperature,
    pvGenerationDay,
    pvGenerationTotal,
    systemInfo,
    peakPower,
    co2,
    currency,
    pvPower,
    graph,
    logo,
  }
}
